export const underlineStyle = {
    textDecorationLine: "underline",
    textDecorationStyle: "dashed",
    textUnderlineOffset: "3px"  
  }